import { loadProgram, getProgramDayForDate, getProgramByIndex, getProgramLength, parseDate } from './dataAdapter.js';
import { initRouter, getDateFromLocation, updateUrlForDate } from './router.js';
import { initUI, renderWorkoutDay, loadExercises } from './ui.js';
import { initTheme, toggleTheme } from './theme.js';
import './styles.css';

let currentIndex = 0;

async function init() {
  // Initialize theme first to prevent FOUC
  initTheme();

  // Load program data and exercise descriptions
  await Promise.all([loadProgram(), loadExercises()]);

  // Determine initial date from URL or use today
  const urlDate = getDateFromLocation();
  const today = new Date();
  const initialDate = urlDate || today;

  // Get the program day for this date
  const initialDay = getProgramDayForDate(initialDate);
  currentIndex = initialDay.index;

  // Initialize UI with handlers
  initUI({
    onNext: handleNext,
    onPrev: handlePrev,
    onToday: handleToday,
    onThemeToggle: toggleTheme
  });

  // Render the current day
  renderCurrentDay(true);

  // Initialize router for popstate handling
  initRouter((date) => {
    const day = getProgramDayForDate(date || new Date());
    currentIndex = day.index;
    renderCurrentDay(false);
  });
}

function renderCurrentDay(replaceUrl) {
  const day = getProgramByIndex(currentIndex);
  const isFirst = currentIndex === 0;
  const isLast = currentIndex === getProgramLength() - 1;

  renderWorkoutDay(day, { isFirst, isLast });

  const dateForDay = parseDate(day.date);
  updateUrlForDate(dateForDay, replaceUrl);
}

function handleNext() {
  if (currentIndex < getProgramLength() - 1) {
    currentIndex++;
    renderCurrentDay(false);
  }
}

function handlePrev() {
  if (currentIndex > 0) {
    currentIndex--;
    renderCurrentDay(false);
  }
}

function handleToday() {
  const today = new Date();
  const day = getProgramDayForDate(today);
  currentIndex = day.index;
  renderCurrentDay(false);
}

// Start the app
init();
